export default "__VITE_ASSET__DL4Ovuv9__"